import * as i0 from '@angular/core';
import { input, computed, output, viewChild, signal, effect, Component, Optional, Inject, HostListener, inject } from '@angular/core';
import { getIconInfo } from '@futura/futura-ui/core';
import { MatIcon } from '@angular/material/icon';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import * as i2 from '@angular/material/bottom-sheet';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import * as i3 from '@jsverse/transloco';
import { TranslocoModule } from '@jsverse/transloco';
import { IconTitleComponent } from '@futura/futura-ui/icon-title';
import { COMPONENT_STATE } from '@futura/futura-ui/ghost';
const _c0 = ["closeIcon"];
const _c1 = ["*", [["", "actions", ""]]];
const _c2 = ["*", "[actions]"];
const _c3 = (a0, a1) => ({
  "justify-content-between": a0,
  "justify-content-end": a1
});
const _c4 = a0 => ({
  "title-ellipses": a0
});
function BaseDialogComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 9);
    i0.ɵɵlistener("click", function BaseDialogComponent_Conditional_1_Conditional_2_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.iconClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const iconDialog_r3 = ctx;
    i0.ɵɵproperty("fontSet", iconDialog_r3.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", iconDialog_r3.icon, " ");
  }
}
function BaseDialogComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "transloco");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4, ctx_r1.titleEllipses()));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx));
  }
}
function BaseDialogComponent_Conditional_1_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const label_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(label_r4);
  }
}
function BaseDialogComponent_Conditional_1_Conditional_6_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BaseDialogComponent_Conditional_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BaseDialogComponent_Conditional_1_Conditional_6_ng_container_0_Template, 1, 0, "ng-container", 10);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngTemplateOutlet", ctx);
  }
}
function BaseDialogComponent_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 11, 0);
    i0.ɵɵlistener("click", function BaseDialogComponent_Conditional_1_Conditional_7_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const closeIcon_r6 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close(closeIcon_r6));
    });
    i0.ɵɵtext(2, "close ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c4, !ctx_r1.titleEllipses()));
  }
}
function BaseDialogComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 4);
    i0.ɵɵtemplate(2, BaseDialogComponent_Conditional_1_Conditional_2_Template, 2, 2, "mat-icon", 5)(3, BaseDialogComponent_Conditional_1_Conditional_3_Template, 3, 6, "h3", 6);
    i0.ɵɵrepeaterCreate(4, BaseDialogComponent_Conditional_1_For_5_Template, 2, 1, "span", 7, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(6, BaseDialogComponent_Conditional_1_Conditional_6_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BaseDialogComponent_Conditional_1_Conditional_7_Template, 3, 3, "mat-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    let tmp_2_0;
    let tmp_3_0;
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c3, !!(ctx_r1.title() || ((tmp_1_0 = ctx_r1.infoLabels()) == null ? null : tmp_1_0.length)), !(ctx_r1.title() || ((tmp_1_0 = ctx_r1.infoLabels()) == null ? null : tmp_1_0.length))));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_2_0 = ctx_r1.iconDialog()) ? 2 : -1, tmp_2_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_3_0 = ctx_r1.title()) ? 3 : -1, tmp_3_0);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.infoLabels());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_5_0 = ctx_r1.titleTemplate()) ? 6 : -1, tmp_5_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.hideCloseIcon() ? 7 : -1);
  }
}
const _c5 = (a0, a1, a2) => ({
  "justify-content-between": a0,
  "justify-content-start": a1,
  "justify-content-end": a2
});
function BaseDialogIconComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 8);
    i0.ɵɵlistener("click", function BaseDialogIconComponent_Conditional_2_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.iconLeftClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const iconDialog_r3 = ctx;
    i0.ɵɵproperty("fontSet", iconDialog_r3.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", iconDialog_r3.icon, " ");
  }
}
function BaseDialogIconComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 9);
    i0.ɵɵlistener("click", function BaseDialogIconComponent_Conditional_3_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close("icon"));
    });
    i0.ɵɵtext(1, "close ");
    i0.ɵɵelementEnd();
  }
}
let BaseDialogComponent = /*#__PURE__*/(() => {
  class BaseDialogComponent {
    constructor(dialogData, bottomSheetData, dialogRef, bottomSheetRef, elementRef) {
      this.dialogRef = dialogRef;
      this.bottomSheetRef = bottomSheetRef;
      this.elementRef = elementRef;
      this.dialogTitle = input();
      this.infoLabels = input([]);
      this.hideClose = input();
      this.infoMenu = input();
      this.icon = input();
      this.titleEllipses = input(true);
      this.titleTemplate = input();
      this.showTitle = computed(() => {
        return !!(this.dialogTitle() || this.infoLabels()?.length > 0 || this.icon() || !this.hideClose());
      });
      this.iconDialog = computed(() => {
        const icon = this.icon();
        if (!icon) {
          return null;
        }
        if (typeof icon !== 'string' && !icon.icon) {
          return null;
        }
        return getIconInfo(icon);
      });
      this.iconClicked = output();
      this.closeDialog = output();
      this.closeIcon = viewChild('closeIcon');
      this.title = signal('');
      this.hideCloseIcon = signal(false);
      effect(() => {
        const closeIcon = this.closeIcon();
        if (!closeIcon) {
          return;
        }
        this.closeMatIcon = closeIcon;
      });
      effect(() => {
        const dialogTitle = this.dialogTitle();
        this.title.set(dialogTitle || '');
      }, {
        allowSignalWrites: true
      });
      effect(() => {
        this.hideCloseIcon.set(!!this.hideClose());
      }, {
        allowSignalWrites: true
      });
      const data = dialogData || bottomSheetData;
      if (!data) {
        return;
      }
      if (data.title && !this.title()) {
        this.title.set(data.title);
      }
      if (data.hideClose != null && this.hideCloseIcon() == null) {
        this.hideCloseIcon.set(data.hideClose);
      }
    }
    onClick(event) {
      if (!this.infoMenu()) {
        return;
      }
      if (this.closeMatIcon?._elementRef?.nativeElement.contains(event.target)) {
        return;
      }
      if (this.elementRef.nativeElement.contains(event.target)) {
        event.stopImmediatePropagation();
      }
    }
    close(closeIcon) {
      if (!this.closeMatIcon) {
        this.closeMatIcon = closeIcon;
      }
      if (this.infoMenu()) {
        return;
      }
      this.closeDialog.emit();
      this.dialogRef?.close();
      this.bottomSheetRef?.dismiss();
    }
    static {
      this.ɵfac = function BaseDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA, 8), i0.ɵɵdirectiveInject(MAT_BOTTOM_SHEET_DATA, 8), i0.ɵɵdirectiveInject(i1.MatDialogRef, 8), i0.ɵɵdirectiveInject(i2.MatBottomSheetRef, 8), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseDialogComponent,
        selectors: [["fut-base-dialog"]],
        viewQuery: function BaseDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.closeIcon, _c0, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostBindings: function BaseDialogComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function BaseDialogComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
        },
        inputs: {
          dialogTitle: [1, "dialogTitle"],
          infoLabels: [1, "infoLabels"],
          hideClose: [1, "hideClose"],
          infoMenu: [1, "infoMenu"],
          icon: [1, "icon"],
          titleEllipses: [1, "titleEllipses"],
          titleTemplate: [1, "titleTemplate"]
        },
        outputs: {
          iconClicked: "iconClicked",
          closeDialog: "closeDialog"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c2,
        decls: 5,
        vars: 1,
        consts: [["closeIcon", ""], [1, "d-flex", "flex-column", "fut-gap-8"], ["mat-dialog-title", "", 1, "d-flex", "align-items-center", "top-container", 3, "ngClass"], ["mat-dialog-content", ""], [1, "d-flex", "title-container", "fut-gap-4"], [1, "fut-m-r-8", 3, "fontSet"], [1, "fut-h3", "fut-m-b-0", 3, "ngClass"], [1, "fut-small", "fut-chip-label"], ["fontSet", "material-symbols-outlined", 1, "pointer", "fut-text-opacity", 3, "ngClass"], [1, "fut-m-r-8", 3, "click", "fontSet"], [4, "ngTemplateOutlet"], ["fontSet", "material-symbols-outlined", 1, "pointer", "fut-text-opacity", 3, "click", "ngClass"]],
        template: function BaseDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, BaseDialogComponent_Conditional_1_Template, 8, 8, "div", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(4, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showTitle() ? 1 : -1);
          }
        },
        dependencies: [NgClass, MatDialogTitle, MatIcon, MatDialogContent, TranslocoModule, i3.TranslocoPipe, NgTemplateOutlet],
        styles: [".top-container[_ngcontent-%COMP%]{width:100%;padding:0}.title-container[_ngcontent-%COMP%]{width:90%}.title-container[_ngcontent-%COMP%]   .title-ellipses[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.title-container[_ngcontent-%COMP%]   .fut-chip-label[_ngcontent-%COMP%]{--background-color: var(--fut-secondary-800);color:#fff;font-weight:700;border-radius:.4em}mat-icon.title-ellipses[_ngcontent-%COMP%]{align-self:baseline}"]
      });
    }
  }
  return BaseDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseDialogIconComponent = /*#__PURE__*/(() => {
  class BaseDialogIconComponent {
    constructor() {
      this.dialogRef = inject(MatDialogRef, {
        optional: true
      });
      this.bottomSheetRef = inject(MatBottomSheetRef, {
        optional: true
      });
      this.state = input(COMPONENT_STATE.NONE);
      this.enableAutoClose = input(true);
      this.dialogIcon = input('');
      this.showSpinner = input();
      this.hideCloseButton = input(false);
      this.dialogTitle = input('');
      this.titleClass = input('');
      this.dialogSubtitle = input();
      this.subtitleClass = input('');
      this.iconLeft = input();
      this.iconDialogLeft = computed(() => {
        const icon = this.iconLeft();
        if (!icon) {
          return null;
        }
        if (typeof icon !== 'string' && !icon.icon) {
          return null;
        }
        return getIconInfo(icon);
      });
      this.iconLeftClicked = output();
      this.closeDialog = output();
    }
    close(place) {
      this.closeDialog.emit(place);
      if (!this.enableAutoClose()) {
        return;
      }
      this.dialogRef?.close();
      this.bottomSheetRef?.dismiss();
    }
    static {
      this.ɵfac = function BaseDialogIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseDialogIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseDialogIconComponent,
        selectors: [["fut-base-dialog-icon"]],
        inputs: {
          state: [1, "state"],
          enableAutoClose: [1, "enableAutoClose"],
          dialogIcon: [1, "dialogIcon"],
          showSpinner: [1, "showSpinner"],
          hideCloseButton: [1, "hideCloseButton"],
          dialogTitle: [1, "dialogTitle"],
          titleClass: [1, "titleClass"],
          dialogSubtitle: [1, "dialogSubtitle"],
          subtitleClass: [1, "subtitleClass"],
          iconLeft: [1, "iconLeft"]
        },
        outputs: {
          iconLeftClicked: "iconLeftClicked",
          closeDialog: "closeDialog"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c2,
        decls: 10,
        vars: 14,
        consts: [["mat-dialog-title", "", 1, "w-100", "d-flex", "flex-column", "justify-content-center", "align-items-center"], [1, "d-flex", "w-100", 3, "ngClass"], [1, "fut-text-opacity", "fut-m-r-8", 3, "fontSet"], ["fontSet", "material-symbols-outlined", 1, "pointer", "fut-text-opacity"], [3, "state", "image", "subtitle", "iconTitle", "showSpinner", "subtitleClass", "titleClass"], ["mat-dialog-content", "", 1, "dialog-icon-simulation-content"], [1, "row", "dialog-main-content"], [1, "col"], [1, "fut-text-opacity", "fut-m-r-8", 3, "click", "fontSet"], ["fontSet", "material-symbols-outlined", 1, "pointer", "fut-text-opacity", 3, "click"]],
        template: function BaseDialogIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, BaseDialogIconComponent_Conditional_2_Template, 2, 2, "mat-icon", 2)(3, BaseDialogIconComponent_Conditional_3_Template, 2, 0, "mat-icon", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "fut-icon-title", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5)(6, "div", 6)(7, "div", 7);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd()()();
            i0.ɵɵprojection(9, 1);
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c5, !!ctx.iconDialogLeft() && !ctx.hideCloseButton(), ctx.hideCloseButton(), !ctx.iconDialogLeft() && !ctx.hideCloseButton()));
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_1_0 = ctx.iconDialogLeft()) ? 2 : -1, tmp_1_0);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.hideCloseButton() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("state", ctx.state())("image", ctx.dialogIcon())("subtitle", ctx.dialogSubtitle())("iconTitle", ctx.dialogTitle())("showSpinner", ctx.showSpinner())("subtitleClass", ctx.subtitleClass())("titleClass", ctx.titleClass());
          }
        },
        dependencies: [MatIcon, MatDialogTitle, MatDialogContent, IconTitleComponent, NgClass],
        styles: ["[_nghost-%COMP%]{--title-height: 12.57em}[_nghost-%COMP%]   .dialog-icon-simulation-content[_ngcontent-%COMP%]{overflow-x:hidden;margin:.71em calc(-1 * var(--paddingfut-dialog));padding-left:var(--paddingfut-dialog);padding-right:var(--paddingfut-dialog)}@media screen and (max-width: 767px){[_nghost-%COMP%]   .dialog-icon-simulation-content[_ngcontent-%COMP%]{max-height:calc(90svh - var(--title-height))}}[_nghost-%COMP%]   .dialog-icon-simulation-content[_ngcontent-%COMP%]   .dialog-main-content[_ngcontent-%COMP%]{max-width:64em;padding-top:.71em;padding-bottom:.71em}[_nghost-%COMP%]   .mat-mdc-dialog-title[_ngcontent-%COMP%]     fut-icon-title p{line-height:normal;font-weight:400;letter-spacing:normal}"]
      });
    }
  }
  return BaseDialogIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BaseDialogComponent, BaseDialogIconComponent };
